module.exports = __webpack_public_path__ + "static/img/logo-acst.11e12bec.svg";